import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

export default function LazyImage({img, width, height}) {
  return (
    <LazyLoadImage src={img} effect='blur' threshold={300} width={width} height={height}/>
  )
};